
import { reactive, ref, toRefs, unref, onMounted, defineComponent } from "vue";
//引入vue方法
import Edit from "./Edit.vue";
import { ElConfigProvider } from "element-plus";
import type { ElForm } from 'element-plus';
//中文包
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { getCustomer ,delCustomer} from "@/api/backstage";
import { ElMessage } from "element-plus";
 import { getEnum } from "@/api/index";
type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  name: "数字展厅",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    Edit,
  },
  setup() {
    let locale = zhCn;
    const dataMap: any = reactive({
      ruleFormRef: ref<FormInstance>(),
      dialogVisible: false,
      customerType:'',
      rows: "",
      tableData: [],
      total: 0,
      time: "",
      form: {
        title: "",
        pageNum: 1,
        pageSize: 10,
      },
      async getList() {
        const data = await getCustomer(this.form);
         for(const item of data.data.list){
          if(item.fileName){
            item.fileUrl =  localStorage.getItem("fileUrel") + item.fileName;
          }
        }
        dataMap.tableData = data?.data.list ?? [];
        dataMap.total = data?.data.total ?? 0;
      },
      async delDataList(ids: any) {
        const baseId = { id: ids };
        const res = await delCustomer(baseId);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          dataMap.getList();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
      async getCoustemType() {
        dataMap.customerType = {};
        const menus = await getEnum("CUSTOMER");
        for (const item of menus.data) {
          dataMap.customerType[item.enumKey] = item;
        }
      },
    });
    const onSubmit = () => {
      dataMap.getList();
    };

    const resetForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
      dataMap.getList();
    };

    const handleSizeChange = (val: number) => {
      dataMap.form.pageSize = val;
      dataMap.getList();
    };
    const handleCurrentChange = (val: number) => {
      dataMap.form.pageNum = val;
      dataMap.getList();
    };
    const addClick = (row: any) => {
      dataMap.dialogVisible = true;
      dataMap.rows = "";
    };
    const close = (val: any) => {
      dataMap.dialogVisible = false;
      dataMap.getList();
    };
    const editClick = (row: any) => {
      dataMap.dialogVisible = true;
      dataMap.rows = row;
    };
    const confirmEvent = (row: any, index: any) => {
      dataMap.delDataList(row.id);
    };
    onMounted(() => {
      dataMap.getList();
      dataMap.getCoustemType();
    });

    return {
      locale,
      close,
      onSubmit,
      resetForm,
      editClick,
      addClick,
      confirmEvent,
      handleSizeChange,
      handleCurrentChange,
      ...toRefs(dataMap),
    };
  },
});
